const topbar = {
    docs: 'Tài liệu',
    help: 'Trợ giúp',
    subscription: 'Gói đăng ký',
};
export default Object.freeze(topbar);
